import React from 'react';
import { Chip } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

const TechStatusChip = (params) => {
  let color = 'info';
  let label = '제안영업';
  switch (params.row.techGrade) {
    case '0':
      label = "제안영업"
      color = 'info';
      break;
    case '1':
      label = "착수보고"
      color = 'error';
      break;
    case '2':
      label = "분석설계"
      color = 'success';
      break;
    case '3':
      label = "구축(이행)"
      color = 'secondary';
      break;
    case '4':
      label = "완료(검수)"
      color = 'warning';
      break;
    default:
      break;
  }

  return (
    <Chip
      icon={<CircleIcon />}
      label={label}
      variant="outlined"
      color={color}
    />
  );
};

export default TechStatusChip;
